import { createPortal } from 'react-dom';
import { Context } from "./jobs-wrapper";
import { useState, useContext, useRef, useEffect} from "react";
import {removeMainCat, getFullState,FixAnyOfTheseJobType} from '../helpers/helpers.js';
import qs from 'query-string';

if (typeof window.kw_from_search === 'undefined') window.kw_from_search = "";
if (typeof window.predefined_cats === 'undefined') window.predefined_cats = [];
if (typeof window.were_facets_used === 'undefined') window.were_facets_used = false;


const Facets = () => {
    const queryParams = qs.parse(window.location.search);
    const className = queryParams.utm_source === 'soliant-test' && queryParams.utm_campaign === 'job-filters' ? '' : '';
    const shouldShowModal = queryParams.utm_source === 'soliant-test' && queryParams.utm_campaign === 'job-filters';

    const {data, loading, updateJobParams, updatePageIndex, updateInputs, inputs, modalJobSearchUsed, updateModalJobSearchUsed} = useContext(Context);

    //const [inputs, setInputs] = useState({"keywords" : window.kw_from_search}); //retains input information (keyword) - structure: {"keywords":"nurses"}
    const [checkboxes, setCheckboxes] = useState({}); //retains which checkboxes were clicked after a search  - structure:
    const [cityCheckboxValues, setCityCheckboxValues] = useState([]); //sets city dropdowns when a state is clicked - structure: [{"key":"Anchorage","doc_count":19,"state":"AK"},{"key":"Anchorage ","doc_count:1,"state":"AK"}]
    const stateCheckboxValues = useRef([]); //retains state/city list after a filtered search - structure: [{"key":"AK","doc_count":57,"city-list":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[{"key":"Anchorage","doc_count":19,"state":"AK"},{"key":"Anchorage ","doc_count":1,"state":"AK"},{"key":"Barrow","doc_count":7,"state":"AK"}]
    const categoryCheckboxValues = useRef([]); //retains cat list after a filtered search - structure: [{"key":"Schools - Adaptive Physical Education Teacher","doc_count":3,"cleaned_key":"Adaptive Physical Education Teacher"}]
    const typeCheckboxValues = useRef([]); //sets type dropdowns when a type is clicked - structure: [{"key":"Contract","doc_count":19}]
    const firstFacetSelected = useRef(""); //sets the name of the first facet selected so we can make any of the first facet group checked "and" searches
    const stateFacetsChecked = useRef([0, 0]); //counts the number of checked states & checks the previous checked count . this is to decide if we should render the city facet after the data loads or before (to prevent city "flashes") only if we have a city checked prior should it not flash  
    const doCityFacetsExist = useRef(0);

    

    //console.log("firstFacetSelected.current: " + firstFacetSelected.current)

   
    if (typeof data.hits !== 'undefined' && firstFacetSelected.current === "") {
        categoryCheckboxValues.current = data.aggregations.categorieslist.buckets;
        typeCheckboxValues.current = data.aggregations.typelist.buckets;
        stateCheckboxValues.current = data.aggregations.stateslist.buckets;
    }

    if (!loading) {
        document.body.classList.remove("ajax-jobs-loading");
    }
    else {
        //activate blurring
        document.body.classList.add("ajax-jobs-loading");
    }

    const resetFacets = () => {
        document.querySelectorAll('.jobFacetsInner input[type="checkbox"]').forEach(el=> {
            if (el.checked) el.click();
        })
        setCheckboxes({})
        setCityCheckboxValues([])
        typeCheckboxValues.current = [];
        stateCheckboxValues.current = [];
        categoryCheckboxValues.current = [];
        firstFacetSelected.current = "";
        stateFacetsChecked.current = [0, 0];
        window.were_facets_used = false;
    }

   /* this is used to populate city facets. -> updates city job counts and filters cities based on any cat and type checked facets */
    const createNewCityArr = () => {
        /* if a city has been checked, we'll use cityCheckboxValues to populate the facets, otherwise, lets use data.aggregations.stateslist.buckets */
        let final_list_of_cities = [];


      //  console.log("CHK Values: " + JSON.stringify(cityCheckboxValues));    



        /*
            IF a city is already checked, keep the previous set of values
            OR if a state was already checked and filtering by facets show no results, keep the city values  
        */



        //if (city_is_checked || (state_is_checked && data.hits.total.value === 0)) {
        if (stateFacetsChecked.current[0] > 0) {    
           /// console.log("City Data: Use current list");
            final_list_of_cities = cityCheckboxValues;
        }
        else {
            //loop through each state from search data
            data.aggregations.stateslist.buckets.forEach(state => {

                /* extract each city and add teh state to it so we have
                * before: {"key":" Atchison ","doc_count":1},{"key":" Lawrence","doc_count":1}
                *after {"key":" Atchison ","doc_count":1,"state":"KS"},{"key":" Lawrence","doc_count":1,"state":"KS"}
                */ 
            //    console.log("City Data: Use Buckets");
                let city_arr = state["city-list"].buckets.map(s => ({...s, state:state.key}))

                //take each city object and push to final_list_of_cities array
                city_arr.forEach(city => {
                    //city.key = city.key.trim()
                    final_list_of_cities.push(city) 
                })

            })  

            //reorder by alpha since we had to trim leading spaces
            //final_list_of_cities.sort((a,b)=> (a.key.toLowerCase() > b.key.toLowerCase() ? 1 : -1)) //sort by alpha
        }


        return final_list_of_cities
    }

    const buildCategoryMarkup = () => {
        if (typeof data.hits !== 'undefined') {
           
            /*
            * Conditions:
            * IF firstFacetSelected.current we want to keep previous checked values from categoryCheckboxValues
            * OR if facets were clicked and no results showed (mainly with cities) we still want the original facets/facets selections to retain
            */ 
            if ((categoryCheckboxValues.current.length > 0 && (firstFacetSelected.current === "cat" || data.hits.total.value === 0))) {

                //console.log("Use catvalues: " + JSON.stringify(categoryCheckboxValues.current))
                return (
                    <>
                    {categoryCheckboxValues.current.map((row, index) => (
                        <div class="wrapCheckFilterGroup filter-cat">
                            <input id={"cat"+index} class="cat-chk" name={"cat"+index} type="checkbox" data-type="cat" value={row["key"]} checked={checkboxes[row["key"]]} onChange={handleChkChange} />
                            <label for={"cat"+index}>{row["cleaned_key"]} ({row["doc_count"]})</label>
                        </div>
                    ))}
                    </>
                )    
            }
            else {


                //remove main cat from categories
                data.aggregations.categorieslist.buckets.forEach((row) => {
                    row["cleaned_key"] = removeMainCat(row["key"]); 
                });
            
                //reorder by alpha
                data.aggregations.categorieslist.buckets.sort((a,b)=> (a.cleaned_key.toLowerCase() > b.cleaned_key.toLowerCase() ? 1 : -1)) //sort by alpha


                //console.log("Don't Use catvalues: " + JSON.stringify(checkboxes))
                categoryCheckboxValues.current = data.aggregations.categorieslist.buckets; //fixes a bug where if facets were selected and a kw search happens with no results, the facets would revert back to "unfiltered" versions

                return (
                    <>
                    {data.aggregations.categorieslist.buckets?.map((row, index) => (
                        <div class="wrapCheckFilterGroup filter-cat">
                            <input id={"cat"+index} class="cat-chk" name={"cat"+index} type="checkbox" data-type="cat" value={row["key"]} checked={checkboxes[row["key"]]} onChange={handleChkChange} />
                            <label for={"cat"+index}>{row["cleaned_key"]} ({row["doc_count"]})</label>
                        </div>
                    ))}
                    </>
                )
            }
    
           
        }
    }
    
    const buildTypeMarkup = () => {
        if (typeof data.hits !== 'undefined') {
            
            /*
            data.aggregations.typelist.buckets.forEach((row, index, object) => {
                if (row["key"].match(/Any Of These/i)) {
                    object.splice(index, 1); //remove "Any Of These"
                }
            })
            */

            /*
            * Conditions:
            * IF firstFacetSelected.current we want to keep previous checked values from typeCheckboxValues
            * OR if facets were clicked and no results showed (mainly with cities) we still want the original facets/facets selections to retain
            */ 
            if (typeCheckboxValues.current.length > 0 && (firstFacetSelected.current === "type" || data.hits.total.value === 0)) {
                return (
                    <>
                        {typeCheckboxValues.current.map((row, index) => (
                            <div class="wrapCheckFilterGroup filter-type">
                                <input id={"type"+index} class="type-chk" name={"type"+index} type="checkbox" data-type="type" value={row["key"]} checked={checkboxes[row["key"]]} onChange={handleChkChange} />
                                <label for={"type"+index}>{FixAnyOfTheseJobType(row["key"])} ({row["doc_count"]})</label>
                            </div>
                        ))} 
                    </>
                )
            } 
            else {
                typeCheckboxValues.current = data.aggregations.typelist.buckets; //fixes a bug where if facets were selected and a kw search happens with no results, the facets would revert back to "unfiltered" versions
                return (
                    <>
                        {data.aggregations.typelist.buckets?.map((row, index) => (
                            <div class="wrapCheckFilterGroup filter-type">
                                <input id={"type"+index} class="type-chk" name={"type"+index} type="checkbox" data-type="type" value={row["key"]} checked={checkboxes[row["key"]]} onChange={handleChkChange} />
                                <label for={"type"+index}>{FixAnyOfTheseJobType(row["key"])} ({row["doc_count"]})</label>
                            </div>
                        ))}    
                        

                    </>
                )
            }

           
        }
    }
    
    const buildStateMarkup = () => {
        if (typeof data.hits !== 'undefined') {

            /*
            * Conditions:
            * IF firstFacetSelected.current we want to keep previous checked values from stateCheckboxValues 
            * OR if facets were clicked and no results showed (mainly with cities) we still want the original facets/facets selections to retain
            */ 
            if (stateCheckboxValues.current.length > 0 && (firstFacetSelected.current === "state" || data.hits.total.value === 0)) {
                return (
                    <>
                        {stateCheckboxValues.current.map((row, index) => (
                            <div class="wrapCheckFilterGroup filter-state">
                                <input id={"state"+index} class="st-chk" name={"state"+index} type="checkbox" data-type="state" value={row["key"]} checked={checkboxes[row["key"]]} onChange={handleChkChange} />
                                <label for={"state"+index}>{getFullState(row["key"])} ({row["doc_count"]})</label>
                            </div>
                        ))}
                    </>
                )
            }
            else {
                stateCheckboxValues.current = data.aggregations.stateslist.buckets; //fixes a bug where if facets were selected and a kw search happens with no results, the facets would revert back to "unfiltered" versions
                return (
                    <>
                        {data.aggregations.stateslist.buckets?.map((row, index) => (
                            <div class="wrapCheckFilterGroup filter-state">
                                <input id={"state"+index} class="st-chk" name={"state"+index} type="checkbox" data-type="state" value={row["key"]} checked={checkboxes[row["key"]]} onChange={handleChkChange} />
                                <label for={"state"+index}>{getFullState(row["key"])} ({row["doc_count"]})</label>
                            </div>
                        ))}
                    </>
                )
            }
            
        }     
    }
    
    const buildCityMarkup = () => {

        let array_to_use = createNewCityArr(),
            checkbox_group = document.querySelector(".filter-city-block .checkbox"),
            states = document.querySelectorAll('.st-chk'),
            state_is_checked = false;


        states.forEach((el) => {
            if (el.checked) {
                state_is_checked = true;
            }
        })


        //reorder by alpha since we had to trim leading spaces
        array_to_use.sort((a,b)=> (a.key.toLowerCase().trim() > b.key.toLowerCase().trim() ? 1 : -1)) //sort by alpha
        
        //console.log("city array_to_use: " + JSON.stringify(array_to_use));
       
        return (
            
            <div class="filter-group filter-city-block show-city-block">
                <span class="lblFilterHeader ui-copy" onClick={mobileMenuFacetToggle}>City <span class="icon-caret-down hidden-sm hidden-md hidden-lg"></span></span>
                <div class="checkbox checkbox-city checkbox-primary col-xs-12 col-sm-12" data-filter-block="City" aria-label="Filter by job city">
                    {array_to_use?.map((row, index) => (
                        <div class="wrapCheckFilterGroup filter-city">
                            <input id={"city"+index} class="city-chk" name={"city"+index} type="checkbox" data-type="City" value={row["key"]} checked={checkboxes[row["key"]+"_city"]} onChange={handleChkChange} />
                            <label for={"city"+index}>{row["key"]}, {row["state"]}  ({row["doc_count"]})</label>
                        </div>
                    ))}
                </div>    
                <div class="clearfix"></div>
                {/*removes view more if greater than 5 results otherwise remove the opened class if it exists */}
                {(array_to_use.length>5) ? (<div class="viewMoreWrap"><button class="viewMore" data-toggle="collapse" aria-expanded="false" aria-controls="collapseCity" onClick={e => handleViewMoreFactesClick(e)}>View More<span class="icon-caret-down"></span></button></div>) : 
                    ((!loading && checkbox_group !== null && checkbox_group.classList.contains("opened")) && checkbox_group.classList.remove("opened"))}
            </div>
        )
           
    }

    const cityMarkupWhenToRender = () => {
        
        if (doCityFacetsExist.current === 0) {
          //  console.log("No Cities Checked: " + doCityFacetsExist.current);
        }
        else {
          //  console.log("Cities Checked: " + doCityFacetsExist.current);
        }

        //if current states checked === 0 and previous states checked === 0 
        if (stateFacetsChecked.current[0] === 1 && stateFacetsChecked.current[1] === 0 && doCityFacetsExist.current === 0) {
            if (!loading)  {
          //      console.log("Wait until load: " + stateFacetsChecked.current);
                return buildCityMarkup();
            }  
        }
        else {
         //   console.log("Don't wait until load: " + stateFacetsChecked.current);
            return buildCityMarkup();
        }
    }
/** OG Buggy - DW 022725 - replaced with function below **/

/*    const handleViewMoreFactesClick = (e) => {
        let facetSibling = e.target.closest(".filter-group").querySelector(".checkbox");

        if (facetSibling.classList.contains("opened")) {
            facetSibling.classList.remove("opened")
            e.target.innerHTML = 'View More <span class="icon-caret-down"></span>'
        }
        else {
            facetSibling.classList.add("opened");
            e.target.innerHTML = 'Show Less <span class="icon-caret-up"></span>'
        }
    }*/
    const handleViewMoreFactesClick = (e) => {
        let facetSibling = e.currentTarget.closest(".filter-group").querySelector(".checkbox");
    
        if (facetSibling.classList.contains("opened")) {
            facetSibling.classList.remove("opened");
            e.currentTarget.innerHTML = 'View More <span class="icon-caret-down"></span>';
        } else {
            facetSibling.classList.add("opened");
            e.currentTarget.innerHTML = 'Show Less <span class="icon-caret-up"></span>';
        }
    };

    //retains search text field query
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        updateInputs(values => ({...values, [name]: value}));
        setKeywords(event.target.value); //allows the clear button to track the value of the search input field
        setShowClearButton(event.target.value.length > 0);

        // Sync to mobile keyword field
        if (name === 'keywords' && typeof window.syncKeywordToMobile === 'function') {
            window.syncKeywordToMobile(value);
        }
    }

    //retains checkbox's checked and does part of the state to city display
    const handleChkChange = (event) => {
        const chkbox = event.target ?? event;
        const type = chkbox.getAttribute("data-type");
        const value = (type === "city") ? chkbox.value + "_city" : chkbox.value; //we need to append a _city if its a city so it's unique (DC fix where we may have a city named "DC") 
        const checked = (chkbox.checked) ? "checked" : "";
        setCheckboxes(values => ({...values, [value]: checked}));


        //console.log("checkbox checked: " + JSON.stringify(checkboxes));
    
        //set firstFacetSelected.current if empty 
        if (firstFacetSelected.current === "" && chkbox.checked) {
            firstFacetSelected.current = type
        }


        //handle State Dropdowns to show cities or remove cities NO LONGER NEEDED (setCityCheckboxValues) BUT WE NEED A CHECK IF A STATE FACET HAS BEEN CHECKED 
        if (type === "state") {

            //set how may facets were previously checked 
            stateFacetsChecked.current[1] = stateFacetsChecked.current[0];

            //set how many facets are checked
            (chkbox.checked) ? stateFacetsChecked.current[0]++ : stateFacetsChecked.current[0]--;


            ((stateCheckboxValues.current.length > 0 && firstFacetSelected.current === "state") ? stateCheckboxValues.current : data.aggregations.stateslist.buckets).forEach(bucket => {
                if (bucket.key === value) {
                    
                    //console.log("state bucket" + JSON.stringify(bucket));

                    bucket["city-list"]["buckets"].forEach((city, index) => {

                        
                        //add the state name to city
                        city["state"] = bucket.key;

                        //console.log("city bucket: " + JSON.stringify(city));
                        
                        //ether add or remove depending if we checked or unchecked boxes
                        if (event.target.checked) {
                            setCityCheckboxValues(values => ([...values, city]))

                            //console.log("target state: " + value)
                            
                        }
                        else {
                            setCityCheckboxValues(values => values.filter(el => {return el.key !== city.key})); //either add cities or remove them from the data of dropdowns
                            checkboxes.current = (values => ({...values, ["city"+index]: ""})); //if we unchcecked the state, we need to uncheck its cities

                            /*
                            * If a state is removed from the "tags", the associated cities dont remove. The following is needed to uncheck the cities so when handleSubmit runs,
                            * the associated cities are already unchceked. 
                            */
                            if (document.querySelector(`input[name="city${index}"]`)) document.querySelector(`[name="city${index}"]`).checked=false;
                        }
                        

                    })
                } 
            })
        }

        //console.log("city values: " + JSON.stringify(cityCheckboxValues))
        //console.log(JSON.stringify(checkboxes))

        handleSubmit()
    }

    //saves facet checked data so when a new facet occurs we dont remove the facet data. Only applicable if a filter/facet was checked and for firstFacetSelected.current 
    const saveFacetClickedData = () => {

        /* 
        The forEaches will retain the "firstFacetSelected.current" values or if theres no "firstFacetSelected.current" yet 
        Otherwise we want to retain the new values from  data.aggregations.xxxxlist.buckets 
        */
       
        if (firstFacetSelected.current === "cat") {
            data.aggregations.categorieslist.buckets?.forEach(cat => {
                //console.log("THE CAT: " + JSON.stringify(cat));
                let check_name_match = obj => obj.key === cat.key;
                if (!categoryCheckboxValues.current.some(check_name_match)) categoryCheckboxValues.current = (values => ([...values, cat]))
            })
        }


        if (firstFacetSelected.current === "type") {

            data.aggregations.typelist.buckets?.forEach(type => {
                let check_name_match = obj => obj.key === type.key;
                if (!typeCheckboxValues.current.some(check_name_match)) typeCheckboxValues.current = (values => ([...values, type]))
            })
        }


        //if (firstFacetSelected.current === "state" || firstFacetSelected.current === "") { //8.16.23 mc not syre why i had  || firstFacetSelected.current === ""
        if (firstFacetSelected.current === "state") {
            data.aggregations.stateslist.buckets?.forEach(state => {
                let check_name_match = obj => obj.key === state.key;
                if (!stateCheckboxValues.current.some(check_name_match)) stateCheckboxValues.current = (values => ([...values, state]))
            })
        }



        

        
    }

    const handleSubmit = (event) => {
        let search_params = {},
            category_values = [],
            type_values = [],
            state_values = [],
            city_values = [],
            categories = document.querySelectorAll('.cat-chk'),
            types = document.querySelectorAll('.type-chk'),
            states = document.querySelectorAll('.st-chk'),
            cities = document.querySelectorAll('.city-chk');
            //console.log("search: " + JSON.stringify(search_params))
            setKeywords(''); // Clear keywords after form submission

        if (event) {
            event.preventDefault();
            resetFacets(); //we reset the facets if "event" exists which means search btn was clicked. We do this since a KW inout search should clear previous filters. 

            /*If we're doing a search from the KW field. clear the modal vars */
            window.cats_from_search = []
            window.location_from_search = []

            if (modalJobSearchUsed === true) {
                updateModalJobSearchUsed(false)
            }

            //console.log("SEARCH PERFORMED")
        }

        //console.log("Submitting");

        //reset
        doCityFacetsExist.current = 0;

        updatePageIndex(1)

           
        
        
        if (inputs.keywords) {
            search_params["keywords"] = inputs.keywords.trim();
            setShowClearButton(true);
          //  console.log('we have inputs.keywords');
        }

        if (!event) {
            //check if categories were selected and add to an array
            categories.forEach((el) => {
                //console.log("EACH CAT:" + el.value)
                if (el.checked) category_values.push(el.value);
            })

            //check if Job types were selected and add to an array
            types.forEach((el) => {
                //console.log("EACH CAT:" + el.value)
                if (el.checked) type_values.push(el.value);
            })

            //check if states were selected and add to an array
            states.forEach((el) => {
                if (el.checked) state_values.push(el.value);
            })

            //check if cities were selected and add to an array
            cities.forEach((el) => {
                if (el.checked) {
                    city_values.push(el.value);
                    //console.log("el.value: " + el.value);
                    //doCityFacetsExist.current = 1;
                }
            })

            if (cities.length) {
                //city exists
                doCityFacetsExist.current = 1;
            }


            //add categories and/or states to search params
            if (category_values.length > 0) search_params["categories"] = category_values 
            if (type_values.length > 0) search_params["types"] = type_values 
            if (state_values.length > 0) search_params["states"] = state_values
            if (city_values.length > 0) search_params["cities"] = city_values


            //if we have some checked facets but the first facet selected checkbox is all unchecked, we need to reset firstFacetSelected.current
            if ((firstFacetSelected.current === "cat" && category_values.length === 0) || 
                (firstFacetSelected.current === "type" && type_values.length === 0) || 
                (firstFacetSelected.current === "state" && state_values.length === 0)) {
                firstFacetSelected.current = ""
            }
    

            //Only retain dropdown facet data if a facet was selected. we excluded city since if no states are checked, city would not be as well.
            //Only retain dropdown facet data if a facet was selected. we excluded city since if no states are checked, city would not be as well.

            /*
            if (category_values.length > 0 || state_values.length > 0 || type_values.length > 0) {
                saveFacetClickedData();  
                window.were_facets_used = true;
                console.log("facets were used");
            }
            else {
                window.were_facets_used = false;
                console.log("facets were not used");
                resetFacets();
            }
            */

            if (Object.keys(checkboxes).length || category_values.length > 0 || state_values.length > 0 || type_values.length > 0) {
                saveFacetClickedData();
                window.were_facets_used = true;
            }
            else {
                window.were_facets_used = false;
                resetFacets();
            }
        }
        
        //update the job params which will trigger search
        updateJobParams(search_params);
        
    }

    const mobileMenuHide = () => {
        document.body.classList.contains("mobile-facets-active") && document.body.classList.remove("mobile-facets-active");
    }
/** OG Buggy - DW 022725 - replaced with function below **/
    /*const mobileMenuFacetToggle = (e) => {
        if (window.innerWidth <= 767) {
            if (e.target.classList.contains("filter-header-active")) {
                e.target.classList.remove("filter-header-active");
                e.target.closest(".filter-group").classList.remove("filter-group-active");
            }
            else {
                e.target.classList.add("filter-header-active");
                e.target.closest(".filter-group").classList.add("filter-group-active");
            }
        }
    }*/
    const mobileMenuFacetToggle = (e) => {
        if (window.innerWidth <= 767) {
            // Use e.currentTarget to target the header element consistently
            const headerElement = e.currentTarget;
    
            if (headerElement.classList.contains("filter-header-active")) {
                headerElement.classList.remove("filter-header-active");
                headerElement.closest(".filter-group").classList.remove("filter-group-active");
            } else {
                headerElement.classList.add("filter-header-active");
                headerElement.closest(".filter-group").classList.add("filter-group-active");
            }
        }
    };
    const [showClearButton, setShowClearButton] = useState(false);
    const [keywords, setKeywords] = useState(''); // Initialize keywords state with an empty string
    
    const handleClear = (event) => {
       // console.log('job search clear button clicked');
        updateInputs({"keywords" : ""})

        setKeywords('');
        setShowClearButton(false);

        // Sync mobile field clear
        if (typeof window.syncKeywordToMobile === 'function') {
            window.syncKeywordToMobile("");
        }

       // setKeywords(event.target.value); //allows the clear button to track the value of the search input field
      };
      /* Sets the text on the search jobs button based on the h1 of the page */
      const [SearchbuttonText, setButtonText] = useState('Search All Jobs');
      useEffect(() => {
        const h1Element = document.querySelector('h1');
        
        if (h1Element) {
          const h1Text = h1Element.textContent;
          if (h1Text === 'Job Search Results') {
            setButtonText('Search All Jobs');
          } else {
            setButtonText('Search ' + h1Text);
          }
        }
        if (inputs.keywords.length > 0) {
            setShowClearButton(true);
          }
      }, [inputs.keywords]);
    

    return (
        <>
         {createPortal(
            <div class="container-full">
                <div class="row">
                <form Id="frm-jobSearch-Bar" class="frmJobSearch noLeftP noRightP" onSubmit={handleSubmit} aria-label="Search our jobs">
                    <div className={`form-group ${className}`}>
                    <label for="inputKW" class="lbl-kw">Job title, location, or keyword</label>
                    <input type="text" class="form-control" id="inputKW" placeholder="Search" name="keywords" title="Search Jobs by Job title, location, or keyword" value={inputs.keywords}  onChange={handleChange}  />
                    {showClearButton && (
                        <span class="x-inside-search" onClick={handleClear}>
                        </span>
                    )}
                    </div>
                    <div class="form-button">
                        <button type="submit" class="btn btn-default" id="btn-searchJobs"> {SearchbuttonText}</button>
                    </div>
                   
                    {(loading) && <div class="lds-css ng-scope jobs-loading">
                        <div style={{width:"100%", height:"100%"}} class="lds-ellipsis">
                        <div><div></div></div>
                        <div><div></div></div>
                        <div><div></div></div>
                        <div><div></div></div>
                        <div><div></div></div>
                        </div>
                    </div>}
                    <div class="job-filter-link" id="jobFilterLink"></div>
                </form>
                </div>
            </div>
            ,document.getElementById("jobSearchbar")
        )}

        {(typeof data.hits !== 'undefined') &&
        <div id="MainPlaceHolder_JobListing_uxFacets" class="jobFacetsWrap col-xs-12 col-sm-4" style={(data.hits.total?.value === 0 && !window.were_facets_used) ? ({display: 'none'}) : ({})}>
            <div class="facets-menu-overlay"></div>
            <button style={{display:'none'}} class="job-filter-close-mobile view-filters-toggle" aria-label="Hide job filters"><i data-feather="x"></i></button>
            <div class="jobFacetsInner filter-list">
                <div class="btn-close-facets facet-closer" onClick={mobileMenuHide}>Cancel <span class="icon-close-x hidden-sm hidden-md hidden-lg"></span></div>

                <div class="filter-group filter-cat-block" style={(!loading && document.querySelector(".filter-cat") === null) ? ({display:'none'}) : ({display:'block'})}>
                    <span class="lblFilterHeader ui-copy" onClick={mobileMenuFacetToggle}>Category<span class="icon-caret-down hidden-sm hidden-md hidden-lg"></span></span>
                    <div class="checkbox checkbox-subcat checkbox-primary col-xs-12 col-sm-12" data-filter-block="Category" aria-label="Filter by job category">
                        {buildCategoryMarkup()} 
                    </div>
                    <div class="clearfix"></div>
                    {/*removes view more if greater than 5 results otherwise remove the opened class if it exists */}
                    {(typeof(document.querySelectorAll('.cat-chk')) !== 'undefined' && document.querySelectorAll('.cat-chk').length>5) ? (<div class="viewMoreWrap"><button class="viewMore" data-toggle="collapse" aria-expanded="false" aria-controls="collapseSubCategory" onClick={e => handleViewMoreFactesClick(e)}>View More<span class="icon-caret-down"></span></button></div>) : 
                        ((!loading && document.querySelector(".filter-cat-block .checkbox").classList.contains("opened")) && document.querySelector(".filter-cat-block .checkbox").classList.remove("opened"))}
                </div>

                <div class="filter-group filter-type-block" style={(!loading && document.querySelector(".filter-type") === null) ? ({display:'none'}) : ({display:'block'})}>
                    <div class="clearfix"></div>
                    <span class="lblFilterHeader ui-copy" onClick={mobileMenuFacetToggle}>Type <span class="icon-caret-down hidden-sm hidden-md hidden-lg"></span></span>
                    <div class="checkbox checkbox-type checkbox-primary col-xs-12 col-sm-12" data-filter-block="Type" aria-label="Filter by job type">
                        {buildTypeMarkup()}
                    </div>
                    <div class="clearfix"></div>
                    {/*removes view more if greater than 5 results otherwise remove the opened class if it exists */}
                    {(typeof(document.querySelectorAll('.type-chk')) !== 'undefined' && document.querySelectorAll('.type-chk').length>5) ? (<div class="viewMoreWrap"><button class="viewMore" data-toggle="collapse" aria-expanded="false" aria-controls="collapseType" onClick={e => handleViewMoreFactesClick(e)} >View More<span class="icon-caret-down"></span></button></div>) : 
                        ((!loading && document.querySelector(".filter-type-block .checkbox").classList.contains("opened")) && document.querySelector(".filter-type-block .checkbox").classList.remove("opened"))}
                </div>

                <div class="filter-group filter-state-block" style={(!loading && document.querySelector(".filter-state") === null) ? ({display:'none'}) : ({display:'block'})}>
                    <span class="lblFilterHeader ui-copy" onClick={mobileMenuFacetToggle}>State <span class="icon-caret-down hidden-sm hidden-md hidden-lg"></span></span>
                    <div class="checkbox checkbox-state checkbox-primary col-xs-12 col-sm-12" data-filter-block="State" aria-label="Filter by job state">
                        {buildStateMarkup()}    
                    </div>
                    <div class="clearfix"></div>
                    {/*removes view more if greater than 5 results otherwise remove the opened class if it exists */}
                    {(document.querySelector(".filter-state") !== null && typeof(document.querySelectorAll('.st-chk')) !== 'undefined' && document.querySelectorAll('.st-chk').length>5) ? (<div class="viewMoreWrap"><button class="viewMore" data-toggle="collapse" aria-expanded="false" aria-controls="collapseSubState" onClick={e => handleViewMoreFactesClick(e)}>View More<span class="icon-caret-down"></span></button></div>) : 
                        ((!loading && document.querySelector(".filter-state-block .checkbox").classList.contains("opened")) && document.querySelector(".filter-state-block .checkbox").classList.remove("opened"))}
                </div>
                
                {(cityCheckboxValues.length > 0) && (cityMarkupWhenToRender())}
                {/*(cityCheckboxValues.length > 0) && (console.log("chkboxvalues for city exist: " + JSON.stringify(cityCheckboxValues)))*/}

                {(!loading) && <div class="filter-controls">
                    <button class="btn btn-close-facets filter-search-btn facet-closer" onClick={mobileMenuHide}>Apply Changes</button>
                    <div><button class="job-filter-clearfacets" onClick={resetFacets}>Clear Filters</button></div>
                </div>}
            </div>
        </div>
        }
        </>
    )
}


export default Facets;